import { Component, OnInit } from '@angular/core'
import { AlertService } from '../../theme/shared'

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html'
})
export class AlertComponent implements OnInit {
  public message: any

  constructor (private _alertService: AlertService) {}

  public ngOnInit () {
    this._alertService.getMessage().subscribe((message) => {
      this.message = message
    })
  }
}
